const practiceOverview = {
  "practice.mode": "Practice Mode",
  "practice.title": "Sharpen the Edge",
  "practice.description": "Practice adapts to your journey — reflecting your progress, targeting your gaps and sharpening what matters most.",
};

const practiceSettings = {
  "practice.game.speed": "Game Speed",
  "practice.difficulty": "Difficulty",
  "practice.scenarios": "Scenarios",
  "practice.awareness.tests": "Awareness Tests",
  "practice.slowtime": "Slowtime for Decisions",
  "practice.level-not-available": "Train to unlock this level",
};

export const practice = {
  ...practiceOverview,
  ...practiceSettings,
};
